import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import AccountOnboardingButton from 'modules/banking/components/AccountOnboarding/Button'

interface AccountCreationModalProps {
  onClose: () => void
  trackingEvent: string | undefined
  source: 'expenses' | 'software'
}

const AccountCreationModal: React.FC<AccountCreationModalProps> = ({
  onClose,
  trackingEvent,
  source,
}) => (
  <Modal
    title={i18n.t('expenses_v2.blank_slate.require_onboarding.modal.title')}
    illustration="document-approved"
    onClose={onClose}
    footer={
      <AccountOnboardingButton
        source={source}
        label={i18n.t('common.start_now')}
        trackingEvent={trackingEvent}
      ></AccountOnboardingButton>
    }
  >
    <Box flexDirection="column" justifyContent="flexStart" alignItems="flexStart" gap="s12">
      <Text.Normal color="grey800">
        {i18n.tView('expenses_v2.blank_slate.require_onboarding.modal.subtitle', {
          expenses_wallet: (
            <Text inline size="300" weight="medium" color="grey1000">
              Expenses Wallet™
            </Text>
          ),
        })}
      </Text.Normal>
      <Box background="champagne400" padding="s16" borderRadius={{ all: 'abs008' }}>
        <Text.Normal color="grey1000">
          {i18n.t('expenses_v2.blank_slate.require_onboarding.modal.description')}
        </Text.Normal>
      </Box>
    </Box>
  </Modal>
)

export default AccountCreationModal
